import type { BuilderPublicShowroomCTACustomFieldConfig } from "api-types/builders/salesConfig";
import type { Column } from "ui/tables/DataTable/types";

export function buildCustomFieldColumns<T>(
  customFields: BuilderPublicShowroomCTACustomFieldConfig[] | undefined,
  getCustomFields: (row: T) => Record<string, string | null> | null | undefined,
  options?: { hide?: boolean },
): Column<T>[] {
  return (customFields ?? []).map((field) => ({
    header: field.name,
    headerTooltip: "Custom fields reflect the customer's most recent answers.",
    id: `custom_${field.id}`,
    accessor: (row: T) => {
      const value = getCustomFields(row)?.[field.name];
      if (field.type === "CHECKBOX") {
        return value === "true" ? "Yes" : "No";
      }
      return value || null;
    },
    fallback: true,
    ...(options?.hide ? { hide: true } : {}),
    enableSorting: false,
  }));
}
